import {gql} from 'apollo-boost';
import {STUDENT_NAME_FIELDS} from '@/queries/fragments/name-fields';

export const GET_STUDENTTOPICLEARN = gql`
  query getStudentTopicLearn($id : ID!){
    getStudentTopicLearn (
      id: $id
    ) {
      id vdoLength learnTime firstPlayVdo startPlayVdo stopPlayVdo learnPercent
      studentUnitLearn { id }
      studentEnrollDetail {
        id
        student {
          ...StudentNameFields
          picturePath
        }
        classSection { id }
      }
      vdoSetUnit { id }
      vdoSetTopic { id }
    }
  }

  ${STUDENT_NAME_FIELDS}
`;

export const GET_STUDENTTOPICLEARNS_BY_FILTER = gql`

  query getStudentTopicLearnsByFilter($studentTopicLearnFilterInput: StudentTopicLearnFilterInput){
    getStudentTopicLearnsByFilter (
      studentTopicLearnFilterInput:$studentTopicLearnFilterInput
    ){
      id vdoLength learnTime firstPlayVdo startPlayVdo stopPlayVdo learnPercent
      studentUnitLearn { id }
      studentEnrollDetail {
        id
        student {
          ...StudentNameFields
          picturePath
        }
        classSection { id }
      }
      vdoSetUnit { id }
      vdoSetTopic { id }

    }
  }

  ${STUDENT_NAME_FIELDS}
`;

export const GET_STUDENTTOPICLEARNS = gql`
  query getStudentTopicLearns {
    getStudentTopicLearns {
      id vdoLength learnTime firstPlayVdo startPlayVdo stopPlayVdo learnPercent
      studentUnitLearn { id }
      studentEnrollDetail {
        id
        student {
          ...StudentNameFields
          picturePath
        }
        classSection { id }
      }
      vdoSetUnit { id }
      vdoSetTopic { id }
    }
  }

  ${STUDENT_NAME_FIELDS}
`;

export const ADD_STUDENTTOPICLEARN = gql`
  mutation addStudentTopicLearn(
    $classSectionId: ID!
    $studentTopicLearnInput: StudentTopicLearnInput!
  ) {
    addStudentTopicLearn(
      classSectionId: $classSectionId
      studentTopicLearnInput: $studentTopicLearnInput
    ) {
      id vdoLength learnTime firstPlayVdo startPlayVdo stopPlayVdo learnPercent
      studentUnitLearn { id }
      studentEnrollDetail {
        id
        student {
          ...StudentNameFields
          picturePath
        }
        classSection { id }
      }
      vdoSetUnit { id }
      vdoSetTopic { id }
    }
  }

  ${STUDENT_NAME_FIELDS}
`;

export const UPDATE_STUDENTTOPICLEARN = gql`
  mutation updateStudentTopicLearn(
    $id: ID!,
    $studentTopicLearnInput: StudentTopicLearnInput!
  ) {
    updateStudentTopicLearn(
      id: $id
      studentTopicLearnInput: $studentTopicLearnInput
    ) {
      id vdoLength learnTime firstPlayVdo startPlayVdo stopPlayVdo learnPercent
      studentUnitLearn { id }
      studentEnrollDetail {
        id
        student {
          ...StudentNameFields
          picturePath
        }
        classSection { id }
      }
      vdoSetUnit { id }
      vdoSetTopic { id }
    }
  }

  ${STUDENT_NAME_FIELDS}
`;
